module.exports = __webpack_public_path__ + "media/Video 101.ead3b911.mp4";